export var DraftExportStage;
(function (DraftExportStage) {
    DraftExportStage[DraftExportStage["Processing"] = 0] = "Processing";
    DraftExportStage[DraftExportStage["Done"] = 1] = "Done";
    DraftExportStage[DraftExportStage["Failed"] = 2] = "Failed";
})(DraftExportStage || (DraftExportStage = {}));
